import { convert } from '../utils'

let lines = [
  {text: ['红杉国家公园及州立公园'],startTime:'00:00:01.00', endTime: '00:00:03.70'},
  {text: ['有着世界上超高的杉树'],startTime:'00:00:03.71', endTime: '00:00:06.19'},
  {text: ['116米的高大身躯'],startTime:'00:00:06.20', endTime: '00:00:08.78'},
  {text: ['让人惊叹大自然的神奇'],startTime:'00:00:08.79', endTime: '00:00:11.57'},
  {text: ['在这里'],startTime:'00:00:12.10', endTime: '00:00:13.03'},
  {text: ['你可以轻松漫步在红衫林间'],startTime:'00:00:13.04', endTime: '00:00:15.70'},
  {text: ['寻找濒临灭绝的野生动物留下的踪迹'],startTime:'00:00:15.71', endTime: '00:00:19.50'},
  {text: ['也可以悠然骑行'],startTime:'00:00:19.51', endTime: '00:00:21.27'},
  {text: ['探索山地秘境'],startTime:'00:00:21.28', endTime: '00:00:23.21'},
  {text: ['5个各具特色的游客中心'],startTime:'00:00:23.22', endTime: '00:00:25.69'},
  {text: ['给你带来不一样的惊喜'],startTime:'00:00:25.70', endTime: '00:00:28.00'},


]

export default convert(lines)
